export default {
    "smileses": [
        "CN[C@]1(C2=C(Cl)C=CC=C2)CCCCC1=O",
        "O=C1O[C@H]([C@@H](O)CO)C(O)=C1O",
        "CC(=O)OC1=CC=CC=C1C(=O)O",
        "CCC(CC)COC(=O)[C@H](C)N[P@](=O)(OC[C@H]1O[C@@](C#N)(C2=CC=C3C(N)=NC=NN23)[C@H](O)[C@@H]1O)OC1=CC=CC=C1",
        "CN1C(=O)C2=C(N=CN2C)N(C)C1=O",
        "O=NN1CC(=O)NC1=O",
        "O=S(=O)(O)OCC1=CC2=CC=CC=C2C2=CC=C3C=CC=CC3=C12",
        "O=C(Cl)C1=CC=C(C(=O)Cl)C=C1"
    ]
}